import { Component, Vue } from 'vue-property-decorator';

import { LOCALES, LANGUAGES, LocaleCode } from '@/locales';

import MainStorage from '@/storage/main';

@Component
export default class LocaleMixin extends Vue {
  get locales() {
    if (this.$route.path.includes('township')) {
      return LOCALES.filter(locale => locale !== LocaleCode.RU);
    }

    return LOCALES;
  }

  get languages() {
    return LANGUAGES;
  }

  get locale() {
    return this.$root.$i18n.locale;
  }

  setLocale(code?: string) {
    if (!code || !this.locales.includes(code)) {
      return;
    }

    this.$root.$i18n.locale = code;

    MainStorage.saveLocale(code);
  }

  localeActive(code: string) {
    return this.locale === code;
  }
}
